<div class="mode-notebook-cell-markdown" [innerHtml]="markdown | markdownParser"></div>
